import { render, staticRenderFns } from "./BaseSpot.vue?vue&type=template&id=72aef04c&"
import script from "./BaseSpot.vue?vue&type=script&lang=js&"
export * from "./BaseSpot.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports